.radio {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  padding: 9px;
  color: var(--tuna-palette-text-secondary);
}

.input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin: 0;
}

.input:focus-visible + .icon {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
  border-radius: 50%;
}

.input:checked + .icon {
  color: var(--tuna-palette-primary-main);
}

.input:disabled + .icon {
  color: var(--tuna-palette-text-disabled);
}

.icon {
  transition: color 150ms;
}

.radioGroup {
  display: flex;
  flex-direction: column;
}

.row {
  flex-direction: row;
}
